export const getters = {
    GET_JOB_APPLICANTS:(state)=>state.jobApplicants,
    GET_JOB_APPLICANT:(state)=>state.jobApplicant
  }
  